var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portlet light" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("ui-dashboard-header", {
          attrs: {
            titulo: "Dashboard",
            subtitulo: "financeiro",
            dataComp: _vm.dataComp,
            permiteColetar: _vm.permiteColetar,
            desabilitaColeta: _vm.utils.ColetaPendente(
              _vm.dashInfo.existeColetaPendente,
              _vm.dashInfo.dataColetaPendente
            ),
            mensagemColeta: _vm.utils.obterMensagemColeta(_vm.dashInfo),
          },
          on: {
            coletarClick: function ($event) {
              return _vm.coletar()
            },
            competenciaChanged: _vm.competenciaChanged,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: {
          "font-size": "40px",
          position: "absolute",
          top: "50%",
          width: "80%",
          left: "12%",
          "z-index": "999",
          "text-align": "center",
        },
      },
      [
        _c("label", [
          _vm._v(
            _vm._s(
              _vm.utils.obterMensagemSemColeta(_vm.dashInfo, _vm.permiteColetar)
            )
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { style: _vm.utils.desabilitarPaginaDash(_vm.dashInfo.existeColeta) },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-lg-4 col-xs12 col-sm-12",
              attrs: { id: "divConciliacaoBancaria" },
            },
            [
              _c("ui-dashboard-charts-with-info", {
                attrs: {
                  infos: _vm.dashInfo.infoConciliacao,
                  title: "Conciliação bancária",
                  idGrafico: "conciliacao",
                  heightChart: "26vh",
                },
                on: {
                  exportar: function ($event) {
                    return _vm.exportarConciliacao()
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-lg-8 col-xs-12 col-sm-12",
              attrs: { id: "divPgtosXRcbtos" },
            },
            [
              _c("ui-dashboard-charts", {
                attrs: { idGrafico: "pgtosXRecbtos", heightChart: "28vh" },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-lg-6 col-xs-12 col-sm-12",
              attrs: { id: "divAgingCRE" },
            },
            [
              _c("ui-dashboard-charts", {
                attrs: { idGrafico: "agingCRE", heightChart: "28vh" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-lg-6 col-xs-12 col-sm-12",
              attrs: { id: "divAgingCPA" },
            },
            [
              _c("ui-dashboard-charts", {
                attrs: { idGrafico: "agingCPA", heightChart: "28vh" },
              }),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }